module.exports = __webpack_public_path__ + "assets/img/9.d09e2d96.jpg";